import createTypes from 'redux-create-action-types';

export default createTypes('SET_APP_SETTINGS');
